import * as React from "react";
const SvgCrop = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M11 3.125C11 2.50625 10.4937 2 9.875 2C9.25625 2 8.75 2.50625 8.75 3.125V8.75H3.125C2.50625 8.75 2 9.25625 2 9.875C2 10.4937 2.50625 11 3.125 11H8.75V27.875C8.75 29.7383 10.2617 31.25 12.125 31.25H26.75V29H12.125C11.5063 29 11 28.4937 11 27.875V3.125ZM29 36.875C29 37.4938 29.5063 38 30.125 38C30.7437 38 31.25 37.4938 31.25 36.875V31.25H36.875C37.4938 31.25 38 30.7437 38 30.125C38 29.5063 37.4938 29 36.875 29H31.25V12.125C31.25 10.2617 29.7383 8.75 27.875 8.75H13.25V11H27.875C28.4937 11 29 11.5063 29 12.125V36.875Z" }));
export default SvgCrop;
